import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

export interface MaintenanceStatus {
  enabled: boolean;
  message: string;
}

@Injectable()
export class MaintenanceService {
  constructor(private http: Http) {}

  getStatus(): Observable<MaintenanceStatus> {
    return this.http.get('/api/maintenance/status')
      .map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/services/maintenance.service.ts